module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product"
  }, [_c('div', [_c('SwiperList', {
    attrs: {
      "swiperList": _vm.swiperList
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-inner"
  }, [_c('div', {
    staticClass: "demo",
    staticStyle: {
      "padding-top": "20px",
      "padding-bottom": "20px"
    },
    attrs: {
      "flex": "dir:left box:first"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "30px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "ul-left"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      class: {
        clicked: item.opermtid === _vm.secondActiveTab
      },
      staticStyle: {
        "position": "relative"
      },
      on: {
        "click": function($event) {
          return _vm.click(index, item)
        }
      }
    }, [_vm._v(_vm._s(item.opermtname) + "\n              "), _c('img', {
      staticStyle: {
        "position": "absolute",
        "top": "20px",
        "right": "25px"
      },
      attrs: {
        "src": require("../../assets/images/jiantou.png"),
        "height": "18",
        "width": "18"
      }
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "right relative",
    staticStyle: {
      "height": "auto",
      "color": "#666"
    }
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "2px solid #f6f6f6",
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "6px",
      "margin-top": "2px",
      "position": "relative"
    }
  }, [_vm._v(_vm._s(_vm.secondTitle) + "\n            "), _c('div', {
    staticStyle: {
      "border-bottom": "2px solid #0061ca",
      "width": "120px",
      "position": "absolute",
      "bottom": "-2px",
      "left": "0"
    }
  })])]), _vm._v(" "), (_vm.operflg === 1) ? _c('div', {
    staticClass: "content-flg",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.contents)
    }
  })]) : (_vm.operflg === 2) ? _c('div', [_c('pic-view', {
    attrs: {
      "pics": _vm.pics
    }
  })], 1) : (_vm.operflg === 3) ? _c('div', {
    staticClass: "news-list"
  }, [_vm._l((_vm.list1), function(item) {
    return _c('div', {
      on: {
        "click": function($event) {
          return _vm.Link(item.operwconid)
        }
      }
    }, [_c('ul', [_c('li', {
      staticClass: "b-d-b",
      staticStyle: {
        "cursor": "pointer",
        "padding": "4px 0"
      }
    }, [_c('span', {
      staticStyle: {
        "margin-right": "5px",
        "color": "#4984c1"
      }
    }, [_vm._v("❉")]), _vm._v(_vm._s(item.operwcontitle) + "\n                "), _c('span', {
      staticStyle: {
        "float": "right",
        "margin-right": "20px"
      },
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(_vm._f("shortDate")(item.createtime)))])])])])
  }), _vm._v(" "), _c('div', [_c('page', {
    attrs: {
      "total": _vm.total,
      "pageSize": _vm.pageSize,
      "currentPage": _vm.currentPage
    },
    on: {
      "pageChanged": _vm.pageChanged
    }
  })], 1)], 2) : (_vm.operflg === 4) ? _c('div', {
    staticClass: "news-list"
  }, [_vm._l((_vm.list1), function(item) {
    return _c('div', [_c('ul', [_c('li', {
      staticClass: "b-d-b",
      staticStyle: {
        "cursor": "pointer",
        "padding": "4px 0"
      }
    }, [_c('span', {
      staticStyle: {
        "margin-right": "5px",
        "color": "#4984c1"
      },
      on: {
        "click": function($event) {
          return _vm.Link(item.operwconid)
        }
      }
    }, [_vm._v("❉")]), _vm._v(_vm._s(item.operwcontitle) + "\n                "), _c('span', {
      staticStyle: {
        "float": "right",
        "margin-right": "20px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.downF(item)
        }
      }
    }, [_vm._v("下载")])])])])
  }), _vm._v(" "), _c('div', [_c('page', {
    attrs: {
      "total": _vm.total,
      "pageSize": _vm.pageSize,
      "currentPage": _vm.currentPage
    },
    on: {
      "pageChanged": _vm.pageChanged
    }
  })], 1)], 2) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticStyle: {
      "color": "#0061ca",
      "padding": "20px 0 20px 25px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#ff8e0a",
      "margin-right": "5px",
      "font-size": "16px",
      "font-weight": "900",
      "margin-top": "-3px"
    }
  }, [_vm._v("|")]), _vm._v("栏目导航"), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("Navgation")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-23328518!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/web/WebProduct.vue
// module id = 295
// module chunks = 0